/* eslint-disable no-undef */

'use strict';

const siteAlert = require('../components/alert');

/**
 * @description create Subscription
 * @returns {void}
 */

module.exports = {
    createSubscription: function () {
        $(document).ready(function () {
            const $newsletterForm = $('#cleverreach-newsletter-form');
            const email = new URLSearchParams(window.location.search).get('email');

            if ($newsletterForm.length && email) {
                window.setTimeout(function () {
                    $('html, body').animate({
                        scrollTop: $newsletterForm.offset().top
                    }, 600);
                }, 150);
            }

            /**
            * Validates the format of an email address using a regular expression.
            *
            * @param {string} email - The email address to be validated.
            * @returns {boolean} - Returns true if the email address is in a valid format, otherwise false.
            */
            function validateEmail(email) {
                let regex = /^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/;
                return regex.test(email);
            }

            /**
             * Builds a full URL by appending query parameters.
             *
             * @param {string} baseUrl - The base URL (absolute or relative) to which query params will be added.
             * @param {Object} params - Optional key-value pairs to append as query parameters.
             * @returns {string|null} - Fully constructed URL with query string or null.
             */
            function buildUrl(baseUrl, params) {
                // early return
                if (!baseUrl) return null;

                const url = new URL(baseUrl, window.location.origin);

                if (params && typeof params === 'object') {
                    Object.entries(params).forEach(([key, value]) => {
                        url.searchParams.set(key, value);
                    });
                }

                return url.toString();
            }

            /**
             * @description Does a subscription call
             * @param {string} email , subscriber email
             */
            function sendSubscriptionRequest(email) {
                $.ajax({
                    type: 'POST',
                    url: CleverReachUrls.footerSubscription,
                    data: { emailAddress: email, source: 'footer' },
                    success: function (response) {
                        if (typeof response === 'string') {
                            try {
                                const jsonString = response.match(/{[^}]*"success":\s*(true|false)[^}]*}/);

                                if (jsonString) {
                                    const jsonResponse = JSON.parse(jsonString[0]);

                                    if (jsonResponse.message) {
                                        $('.newsletter-form').addClass('error');
                                        $('.newsletter-form-error').html(jsonResponse.message);
                                    } else {
                                        window.location.href = buildUrl(CleverReachUrls.subscriptionStatus, { status: jsonResponse.status });
                                    }
                                } else {
                                    window.location.href = CleverReachUrls.subscriptionStatus;
                                }
                            } catch (e) {
                                window.location.href = CleverReachUrls.subscriptionStatus;
                            }
                        }
                    },
                    error: function () {
                        window.location.href = CleverReachUrls.subscriptionStatus;
                    }
                });
            }

            $('#cleverReach-newsletter-subscription button').on('click', function (e) {
                e.preventDefault();
                const $button = $(this);
                const $form = $('#cleverReach-newsletter-subscription');
                const email = $form.find('#email-alert-address').val();
                const invalidEmailMessage = $form.find('#email-alert-address').attr('invalid-email-address');
                const newsletterPageUrl = $(e.target).closest('.newsletter-container').data('newsletter-page-url');
                $form.find('.newsletter-form.error').removeClass('error');

                if (email.length > 0) {
                    if (validateEmail(email)) {
                        window.location.href = buildUrl(newsletterPageUrl, { email: email });
                    } else {
                        $button.attr('disabled', true);

                        siteAlert.show({
                            type: 'error',
                            message: invalidEmailMessage,
                            timeout: 3000,
                            onHide: function () {
                                $button.removeAttr('disabled');
                            }
                        });
                    }
                }
            });

            // Add a checkbox for privacy policy if cleverReach is enabled
            if (window.CleverReachPreferences && window.CleverReachPreferences.cleverReachEnabled && window.CleverReachPreferences.cleverReachEnabled !== false) {
                let elementBefore = '<input type="checkbox" class="input-checkbox privacy-checkbox" value="false" /> ' + window.CleverReachResources.privacyBeforeLink + ' ';
                let elementAfter = ' ' + window.CleverReachResources.privacyAfterLink;

                $('a.privacy-policy').parent().prepend(elementBefore).append(elementAfter);

                $('#dwfrm_billing').on('submit', function (event) {
                    if ($(this).find('input.privacy-checkbox').prop('checked') === false) {
                        event.preventDefault();
                        $('input.privacy-checkbox').parent().addClass('error-privacy');
                    } else {
                        $('input.privacy-checkbox').parent().removeClass('error-privacy');
                    }
                });
                $('#account_subscribe').on('click', function (event) {
                    event.preventDefault();
                    $('.email-signup-wrapper').slideDown(800);
                });
            }

            $('.js-cleverreach-newsletter-form').on('submit', function (e) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                const $form = $(this);
                const url = $form.attr('action');
                const method = $form.attr('method');
                const formData = $form.serialize();

                $form.spinner().start();

                $.ajax({
                    url: url,
                    method: method,
                    data: formData,
                    success: function (response) {
                        if (typeof response === 'string') {
                            try {
                                const jsonString = response.match(/{[^}]*"success":\s*(true|false)[^}]*}/);

                                if (jsonString) {
                                    const jsonResponse = JSON.parse(jsonString[0]);

                                    window.location.href = buildUrl(CleverReachUrls.subscriptionStatus, { status: jsonResponse.status });
                                } else {
                                    window.location.href = CleverReachUrls.subscriptionStatus;
                                }
                            } catch (e) {
                                window.location.href = CleverReachUrls.subscriptionStatus;
                            }
                        } else {
                            window.location.href = buildUrl(CleverReachUrls.subscriptionStatus, { status: response.status });
                        }
                    },
                    error: function () {
                        window.location.href = CleverReachUrls.subscriptionStatus;
                    }
                });
            });
        });
    }
};
